<template>
  <SheetModal
    class="EditStatusNoteModalView"
    data-theme="light"
    fit="hug"
    aria-label="Add a note"
    :aria-busy="isRequesting"
    @close="$emit('close')"
  >
    <form
      class="EditStatusNoteModalView__form"
      @submit.prevent="handleSubmit"
    >
      <fieldset
        class="EditStatusNoteModalView__fieldset"
        :disabled="isRequesting"
      >
        <SheetHeader
          :title="status.note ? 'Edit your note' : 'Add a note'"
          @cancel="$emit('close')"
        />

        <div class="EditStatusNoteModalView__fieldGrid">
          <FormInput
            v-model="form.note"
            name="note"
            autocomplete="off"
            placeholder="Arriving late, Leaving early, Make it rain, etc."
            enterkeyhint="done"
            :rows="3"
            isMultiline
            shouldAutoFocus
            @keydown.enter.prevent="handleSubmit"
          />
        </div>
      </fieldset>
    </form>
  </SheetModal>
</template>

<script lang="ts" setup>
import FormInput from "@/components/FormInput.vue";
import SheetHeader from "@/components/SheetHeader.vue";
import SheetModal from "@/components/SheetModal.vue";
import { supabaseClient } from "@/lib/database/supabase";
import { TablesUpdate } from "@shared/lib/database/database.types";
import { StatusSummary } from "@shared/lib/database/query.types";
import { computed, ref } from "vue";

const status = defineModel<StatusSummary>({
  required: true,
});

const emit = defineEmits<{
  close: [],
}>();

const isRequesting = ref(false);

const form = ref<{
  note: string | null,
}>({
  note: status.value?.note || null,
});

const payload = computed((): TablesUpdate<"statuses"> | undefined => {
  return {
    note: form.value.note?.trim() || null,
  };
});

async function handleSubmit () {
  if (!payload.value) return;

  isRequesting.value = true;

  const {
    data: _status,
    error,
  } = await supabaseClient
    .from("statuses")
    .update(payload.value)
    .eq("run_id", status.value.run_id)
    .eq("player_id", status.value.player_id)
    .select()
    .maybeSingle();

  if (error) {
    alert(error.message);
  } else {
    if (_status) Object.assign(status.value, _status);
    emit("close");
  }

  isRequesting.value = false;
}
</script>

<style lang="scss" scoped>
.EditStatusNoteModalView__fieldset {
  display: grid;
  align-content: start;
  height: 100%;
}

.EditStatusNoteModalView__fieldGrid {
  padding: 16px 16px calc(16px + var(--safeAreaInsetBottom));
}
</style>
